import { render, staticRenderFns } from "./Callcenter.vue?vue&type=template&id=abd4f7f6"
import script from "./Callcenter.vue?vue&type=script&lang=js"
export * from "./Callcenter.vue?vue&type=script&lang=js"
import style0 from "./Callcenter.vue?vue&type=style&index=0&id=abd4f7f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports